import { render, staticRenderFns } from "./SpaceOption.vue?vue&type=template&id=fdd3fdc4&scoped=true"
import script from "./SpaceOption.vue?vue&type=script&lang=ts"
export * from "./SpaceOption.vue?vue&type=script&lang=ts"
import style0 from "./SpaceOption.vue?vue&type=style&index=0&id=fdd3fdc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd3fdc4",
  null
  
)

export default component.exports